import { useQuery } from '@tanstack/react-query';
import {
  procedureTemplateService,
  type ProcedureListFilters,
} from '@/services/procedure-template.service';

export const procedureKeys = {
  all: () => ['procedures'] as const,
  lists: () => [...procedureKeys.all(), 'list'] as const,
  list: (f: ProcedureListFilters) => [...procedureKeys.lists(), f] as const,
  details: () => [...procedureKeys.all(), 'detail'] as const,
  detail: (id: string) => [...procedureKeys.details(), id] as const,
  versions: (id: string) => [...procedureKeys.detail(id), 'versions'] as const,
} as const;

export function useProcedureList(filters: ProcedureListFilters) {
  return useQuery({
    queryKey: procedureKeys.list(filters),
    queryFn: () => procedureTemplateService.list(filters),
    staleTime: 30_000,
  });
}

export function useProcedureTemplate(id: string | undefined) {
  return useQuery({
    queryKey: procedureKeys.detail(id ?? ''),
    queryFn: () => procedureTemplateService.get(id!),
    enabled: !!id,
    staleTime: (query) => {
      const data = query.state.data;
      if (data?.status === 'DRAFT') return 10_000;
      return 5 * 60 * 1000;
    },
  });
}

export function useProcedureVersions(id: string | undefined) {
  return useQuery({
    queryKey: procedureKeys.versions(id ?? ''),
    queryFn: () => procedureTemplateService.getVersions(id!),
    enabled: !!id,
    staleTime: 60_000,
  });
}
